import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  licenses: null,
};

const licenSlice = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    getSuccess: (state, action) => {
      return {
      ...state,
      licenses : action.payload,
    }
  }
}
  
});

export const {
  getSuccess
} = licenSlice.actions;
export const licenReducer = licenSlice.reducer;
